import * as React from 'react';
import { compose, withProps, withHandlers } from 'recompose';
import { reduxForm } from 'redux-form';
import { Prompt } from 'react-router';
import { breadcrumbs, idObj } from '@inqool/uas-web-core/es/utils';
import { get, isUndefined } from 'lodash';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { Card } from 'material-ui/Card';

import { entityDetailEnhancer } from '@components/hoc/entityDetailEnhancer';
import { withConfiguration } from '@components/hoc/withConfiguration';
import { ConfigurationContextInterface } from '@components/provider/configuration/_configurationTypes';
import { configurationValues } from '@components/provider/configuration/_configurationConstants';
import { Tabs } from '@components/tabs';
import { withNotifications } from '@components/hoc/withNotifications';

import { EmployeesFormPersonal } from '@modules/employees/EmployeesFormPersonal';
import { EmployeesFormLogins } from './EmployeesFormLogins';
import { EmployeesFormContracts } from '@modules/employees/EmployeesFormContracts';
import { EmployeesFormTrainings } from '@modules/employees/EmployeesFormTrainings';
import { EmployeesFormCertificates } from '@modules/employees/EmployeesFormCertificates';
import { EmployeesFormFiles } from '@modules/employees/EmployeesFormFiles';
import { EmployeesFormIdentifications } from '@modules/employees/EmployeesFormIdentifications';
import { getEmployee, putEmployee, defaultEmployee } from '@modules/employees/_employeesActions';
import * as T from '@modules/employees/_employeesTypes';
import ExportButton from '@components/exportButton/ExportButton';

export const enhance = compose<T.EmplyeesFormProps, T.Outter>(
  entityDetailEnhancer<T.EmployeeEnhancerProps<T.Employee> & Partial<T.Employee>, T.Employee>({
    getEntity: getEmployee,
    defaultEntity: defaultEmployee
  }),
  breadcrumbs(({ entity }) => [
    { label: 'Zaměstnanci', to: '/employees' },
    { label: get(entity, 'fullName', 'Nový zaměstnanec') }
  ]),
  withProps<{}, T.EmployeeProps>(({ entity }) => ({
    initialValues: {
      ...entity
    },
    hasEntity: !isUndefined(entity)
  })),
  withNotifications({ putEmployee }),
  withHandlers({
    onSubmit: ({ closeItem, putEmployeeNotify }) => async formData => {
      const withId = idObj(formData);
      const response = await putEmployeeNotify(
        withId,
        'Prosím zkontrolujte, jestli ste nezadali již existující jméno nebo služební číslo.'
      );

      if (response) {
        closeItem();
      }
    }
  }),
  reduxForm({ form: 'module-employees' }),
  withConfiguration({})
);

const tabStyle = {
  minWidth: 175,
  fontSize: 12,
  fontWeight: 100
};

export const View: React.SFC<T.Outter & T.EmplyeesFormProps & ConfigurationContextInterface> = ({
  handleSubmit,
  closeItem,
  dirty,
  submitSucceeded,
  submitting,
  config: {
    extensions: { login }
  },
  hasEntity,
  item
}) => (
  <div>
    <Prompt when={dirty && !submitSucceeded && !submitting} message="Vaše změny nebyly uloženy, přesto odejít?" />
    <form className="layout" onSubmit={handleSubmit}>
      <Card>
        <Tabs
          items={[
            { label: 'Osobní', style: tabStyle, content: <EmployeesFormPersonal /> },
            ...(login === configurationValues.config.extensions.login.basic
              ? [
                  {
                    label: 'Přihlášení',
                    style: tabStyle,
                    content: <EmployeesFormLogins hasEntity={hasEntity} />
                  }
                ]
              : []),
            { label: 'Pracovní úvazky', style: tabStyle, content: <EmployeesFormContracts /> },
            { label: 'Školení', style: tabStyle, content: <EmployeesFormTrainings /> },
            { label: 'Osvědčení', style: tabStyle, content: <EmployeesFormCertificates /> },
            { label: 'Osobní soubory', style: tabStyle, content: <EmployeesFormFiles /> },
            { label: 'Doklady totožnosti', style: tabStyle, content: <EmployeesFormIdentifications /> }
          ]}
        />

        <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
        <div style={{ display: 'inline-block', margin: '16px 0 16px 16px' }}>
          <ExportButton
            location="employeeDetail"
            formName="form.module-employees"
            urlPrefix="/metropolis"
            exportLabel="Export"
            input={{ employeeId: item }}
            disabled={!item}
          />
        </div>
      </Card>
    </form>
  </div>
);

export const EmployeesForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/employees/EmployeesForm.tsx